import { IUserRole } from "./constants";

export const actionTypes = {
  FETCH_ALL_USERS: "FETCH_ALL_USERS",
  FETCH_ALL_USERS_SUCCESS: "FETCH_ALL_USERS_SUCCESS",
  FETCH_ALL_USERS_FAILURE: "FETCH_ALL_USERS_FAILURE",

  FETCH_USER_ROLES: "FETCH_USER_ROLES",
  FETCH_USER_ROLES_SUCCESS: "FETCH_USER_ROLES_SUCCESS",
  FETCH_USER_ROLES_FAILURE: "FETCH_USER_ROLES_FAILURE",
  UPDATE_ASSIGNED_ROLES: "UPDATE_ASSIGNED_ROLES",

  FETCH_SELECTABLE_ROLES: "FETCH_SELECTABLE_ROLES",
  FETCH_SELECTABLE_ROLES_SUCCESS: "FETCH_SELECTABLE_ROLES_SUCCESS",
  FETCH_SELECTABLE_ROLES_FAILURE: "FETCH_SELECTABLE_ROLES_FAILURE",

  SELECT_USER_ROLES_MGMT_USER: "SELECT_USER_ROLES_MGMT_USER",

  SET_ADDED_ROLES: "SET_ADDED_ROLES",
  SET_DELETED_ROLES: "SET_DELETED_ROLES",

  SEND_MODIFIED_ROLES: "SEND_MODIFIED_ROLES",
  SEND_MODIFIED_ROLES_SUCCESS: "SEND_MODIFIED_ROLES_SUCCESS",
  SEND_MODIFIED_ROLES_FAILURE: "SEND_MODIFIED_ROLES_FAILURE",

  LOAD_ROLES_MANAGEMENT_ROLES: "LOAD_ROLES_MANAGEMENT_ROLES",
  LOAD_ROLES_MANAGEMENT_ROLES_SUCCESS: "LOAD_ROLES_MANAGEMENT_ROLES_SUCCESS",
  LOAD_ROLES_MANAGEMENT_ROLES_FAILURE: "LOAD_ROLES_MANAGEMENT_ROLES_FAILURE",

  LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES:
    "LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES",
  LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES_SUCCESS:
    "LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES_SUCCESS",
  LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES_FAILURE:
    "LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES_FAILURE",

  SET_ROLE_USERS_SELECTED_ROLE: "SET_ROLE_USERS_SELECTED_ROLE",

  CREATE_OR_UPDATE_ROLE_ACTION: "CREATE_OR_UPDATE_ROLE_ACTION",
  CREATE_OR_UPDATE_ROLE_ACTION_SUCCESS: "CREATE_OR_UPDATE_ROLE_ACTION_SUCCESS",
  CREATE_OR_UPDATE_ROLE_ACTION_FAILURE: "CREATE_OR_UPDATE_ROLE_ACTION_FAILURE",

  DELETE_ROLE_ACTION: "DELETE_ROLE_ACTION",
  DELETE_ROLE_ACTION_SUCCESS: "DELETE_ROLE_ACTION_SUCCESS",
  DELETE_ROLE_ACTION_FAILURE: "DELETE_ROLE_ACTION_FAILURE",

  GET_ROLE_USERS_USERS_ACTION: "GET_ROLE_USERS_USERS_ACTION",
  GET_ROLE_USERS_USERS_ACTION_SUCCESS: "GET_ROLE_USERS_USERS_ACTION_SUCCESS",
  GET_ROLE_USERS_USERS_ACTION_FAILURE: "GET_ROLE_USERS_USERS_ACTION_FAILURE",

  GET_ROLE_USERS_SELECTED_USERS_ACTION: "GET_ROLE_USERS_SELECTED_USERS_ACTION",
  GET_ROLE_USERS_SELECTED_USERS_ACTION_SUCCESS:
    "GET_ROLE_USERS_SELECTED_USERS_ACTION_SUCCESS",
  GET_ROLE_USERS_SELECTED_USERS_ACTION_FAILURE:
    "GET_ROLE_USERS_SELECTED_USERS_ACTION_FAILURE",

  UPDATE_ROLE_USERS_SELECTED_USERS_ACTION:
    "UPDATE_ROLE_USERS_SELECTED_USERS_ACTION",

  CREATE_OR_UPDATE_VISIBILITY_CONE: "CREATE_OR_UPDATE_VISIBILITY_CONE",
  CREATE_OR_UPDATE_VISIBILITY_CONE_SUCCESS:
    "CREATE_OR_UPDATE_VISIBILITY_CONE_SUCCESS",
  CREATE_OR_UPDATE_VISIBILITY_CONE_FAILURE:
    "CREATE_OR_UPDATE_VISIBILITY_CONE_FAILURE",

  DELETE_VISIBILITY_CONE: "DELETE_VISIBILITY_CONE",
  DELETE_VISIBILITY_CONE_SUCCESS: "DELETE_VISIBILITY_CONE_SUCCESS",
  DELETE_VISIBILITY_CONE_FAILURE: "DELETE_VISIBILITY_CONE_FAILURE",

  SET_ROLE_TO_MODIFY: "SET_ROLE_TO_MODIFY",
  SET_VISIBILITY_CONE_TO_MODIFY: "SET_VISIBILITY_CONE_TO_MODIFY",

  UPDATE_ROLE_USERS_ACTION: "UPDATE_ROLE_USERS_ACTION",
  UPDATE_ROLE_USERS_ACTION_SUCCESS: "UPDATE_ROLE_USERS_ACTION_SUCCESS",
  UPDATE_ROLE_USERS_ACTION_FAILURE: "UPDATE_ROLE_USERS_ACTION_FAILURE",

  FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE: "FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE",
  FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE_SUCCESS:
    "FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE_SUCCESS",
  FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE_FAILURE:
    "FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE_FAILURE",
};

export const loadRolesNewVisibilityCone = () => ({
  type: actionTypes.FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE,
});
export const loadRolesNewVisibilityConeSuccess = (payload: any) => ({
  type: actionTypes.FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE_SUCCESS,
  payload,
});
export const loadRolesNewVisibilityConeFailure = (err: Error) => ({
  type: actionTypes.FETCH_LOAD_ROLES_NEW_VISIBILITY_CONE_FAILURE,
  err,
});

export const fetchAllUsersAction = (payload: any) => ({
  type: actionTypes.FETCH_ALL_USERS,
  payload,
});
export const fetchAllUsersSuccessAction = (payload: any) => ({
  type: actionTypes.FETCH_ALL_USERS_SUCCESS,
  payload,
});
export const fetchAllUsersFailureAction = (err: Error) => ({
  type: actionTypes.FETCH_ALL_USERS_FAILURE,
  err,
});

export const selectUserRolesMgmtUserAction = (payload: any) => ({
  type: actionTypes.SELECT_USER_ROLES_MGMT_USER,
  payload,
});

export const fetchUserRolesAction = (payload: any) => ({
  type: actionTypes.FETCH_USER_ROLES,
  payload,
});
export const fetchUserRolesSuccessAction = (payload: any) => ({
  type: actionTypes.FETCH_USER_ROLES_SUCCESS,
  payload,
});
export const fetchUserRolesFailureAction = (payload: any) => ({
  type: actionTypes.FETCH_USER_ROLES_FAILURE,
  payload,
});
export const updateAssignedRolesAction = (payload: IUserRole[]) => ({
  type: actionTypes.UPDATE_ASSIGNED_ROLES,
  payload,
});

export const fetchSelectableRolesAction = () => ({
  type: actionTypes.FETCH_SELECTABLE_ROLES,
});
export const fetchSelectableRolesSuccessAction = (payload: any) => ({
  type: actionTypes.FETCH_SELECTABLE_ROLES_SUCCESS,
  payload,
});
export const fetchSelectableRolesFailureAction = (payload: any) => ({
  type: actionTypes.FETCH_SELECTABLE_ROLES_FAILURE,
  payload,
});

export const setAddedRolesAction = (payload: any) => ({
  type: actionTypes.SET_ADDED_ROLES,
  payload,
});
export const setDeletedRolesAction = (payload: any) => ({
  type: actionTypes.SET_DELETED_ROLES,
  payload,
});

export const sendModifiedRolesAction = (payload: any) => ({
  type: actionTypes.SEND_MODIFIED_ROLES,
  payload,
});
export const sendModifiedRolesSuccessAction = (payload: any) => ({
  type: actionTypes.SEND_MODIFIED_ROLES_SUCCESS,
  payload,
});
export const sendModifiedRolesFailureAction = (error: any) => ({
  type: actionTypes.SEND_MODIFIED_ROLES_FAILURE,
  error,
});

// ROLES MANAGEMENT
export const loadRolesManagementRolesAction = () => ({
  type: actionTypes.LOAD_ROLES_MANAGEMENT_ROLES,
});
export const loadRolesManagementRolesSuccessAction = (payload: any) => ({
  type: actionTypes.LOAD_ROLES_MANAGEMENT_ROLES_SUCCESS,
  payload,
});
export const loadRolesManagementRolesFailureAction = (error: any) => ({
  type: actionTypes.LOAD_ROLES_MANAGEMENT_ROLES_FAILURE,
  error,
});

export const loadRolesManagementVisibilityConesAction = () => ({
  type: actionTypes.LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES,
});
export const loadRolesManagementVisibilityConesSuccessAction = (
  payload: any
) => ({
  type: actionTypes.LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES_SUCCESS,
  payload,
});
export const loadRolesManagementVisibilityConesFailureAction = (
  error: any
) => ({
  type: actionTypes.LOAD_ROLES_MANAGEMENT_VISIBILITY_CONES_FAILURE,
  error,
});

export const setRoleUsersSelectedRoleAction = (payload: any) => ({
  type: actionTypes.SET_ROLE_USERS_SELECTED_ROLE,
  payload,
});

export const createOrUpdateRoleAction = (payload: any) => ({
  type: actionTypes.CREATE_OR_UPDATE_ROLE_ACTION,
  payload,
});
export const createOrUpdateRoleSuccessAction = (payload: any) => ({
  type: actionTypes.CREATE_OR_UPDATE_ROLE_ACTION_SUCCESS,
  payload,
});
export const createOrUpdateRoleFailureAction = (error: any) => ({
  type: actionTypes.CREATE_OR_UPDATE_ROLE_ACTION_FAILURE,
  error,
});

export const deleteRoleAction = (payload: any) => ({
  type: actionTypes.DELETE_ROLE_ACTION,
  payload,
});
export const deleteRoleSuccessAction = (payload: any) => ({
  type: actionTypes.DELETE_ROLE_ACTION_SUCCESS,
  payload,
});
export const deleteRoleFailureAction = (error: any) => ({
  type: actionTypes.DELETE_ROLE_ACTION_FAILURE,
  error,
});

export const createOrUpdateVisibilityConeAction = (payload: any) => ({
  type: actionTypes.CREATE_OR_UPDATE_VISIBILITY_CONE,
  payload,
});
export const createOrUpdateVisibilityConeSuccessAction = (payload: any) => ({
  type: actionTypes.CREATE_OR_UPDATE_VISIBILITY_CONE_SUCCESS,
  payload,
});
export const createOrUpdateVisibilityConeFailureAction = (error: any) => ({
  type: actionTypes.CREATE_OR_UPDATE_VISIBILITY_CONE_FAILURE,
  error,
});

export const deleteVisibilityConeAction = (payload: any) => ({
  type: actionTypes.DELETE_VISIBILITY_CONE,
  payload,
});
export const deleteVisibilityConeSuccessAction = (payload: any) => ({
  type: actionTypes.DELETE_VISIBILITY_CONE_SUCCESS,
  payload,
});
export const deleteVisibilityConeFailureAction = (error: any) => ({
  type: actionTypes.DELETE_VISIBILITY_CONE_FAILURE,
  error,
});

export const setRoleToModifyAction = (payload: any) => ({
  type: actionTypes.SET_ROLE_TO_MODIFY,
  payload,
});
export const setVisibilityConeToModifyAction = (payload: any) => ({
  type: actionTypes.SET_VISIBILITY_CONE_TO_MODIFY,
  payload,
});

// ROLE USERS
export const getRoleUsersUsersAction = (payload: any) => ({
  type: actionTypes.GET_ROLE_USERS_USERS_ACTION,
  payload,
});
export const getRoleUsersUsersSuccessAction = (payload: any) => ({
  type: actionTypes.GET_ROLE_USERS_USERS_ACTION_SUCCESS,
  payload,
});
export const getRoleUsersUsersFailureAction = (error: any) => ({
  type: actionTypes.GET_ROLE_USERS_USERS_ACTION_FAILURE,
  error,
});

export const getRoleUsersSelectedUsersAction = (payload: any) => ({
  type: actionTypes.GET_ROLE_USERS_SELECTED_USERS_ACTION,
  payload,
});
export const getRoleUsersSelectedUsersSuccessAction = (payload: any) => ({
  type: actionTypes.GET_ROLE_USERS_SELECTED_USERS_ACTION_SUCCESS,
  payload,
});
export const getRoleUsersSelectedUsersFailureAction = (error: any) => ({
  type: actionTypes.GET_ROLE_USERS_SELECTED_USERS_ACTION_FAILURE,
  error,
});

export const updateSelectedUsersAction = (payload: any) => ({
  type: actionTypes.UPDATE_ROLE_USERS_SELECTED_USERS_ACTION,
  payload,
});

export const updateRoleUsersAction = (payload: any) => ({
  type: actionTypes.UPDATE_ROLE_USERS_ACTION,
  payload,
});
export const updateRoleUsersSuccessAction = (payload: any) => ({
  type: actionTypes.UPDATE_ROLE_USERS_ACTION_SUCCESS,
  payload,
});
export const updateRoleUsersFailureAction = (payload: any) => ({
  type: actionTypes.UPDATE_ROLE_USERS_ACTION_FAILURE,
  payload,
});
